import { LoyaltyAllowedMatrixDtoListToEntityList } from "src/app/features/LoyaltyAllowedMatrix/services/mappers/LoyaltyAllowedMatrixDtoListToEntityList";
import type { LoyaltyAllowedMatrixQueryParams } from "src/app/features/LoyaltyAllowedMatrix/services/server/LoyaltyAllowedMatrixQueryTypes";
import type { LoyaltyAllowedMatrixEntityList } from "src/app/features/LoyaltyAllowedMatrix/types/LoyaltyAllowedMatrixEntityList";
import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { LoyaltyAllowedMatrixEntity } from "../../types/LoyaltyAllowedMatrixEntity";
import { LoyaltyAllowedMatrixEntityToDto } from "../mappers/LoyaltyAllowedMatrixEntityToDto";

const LoyaltyAllowedMatrixApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        LoyaltyAllowedMatrixLoad: builder.query<LoyaltyAllowedMatrixEntityList, void>({
            providesTags: [ResourceName.LOYALTY_ALLOWED_MATRIX],
            query: () => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.LOYALTY_ALLOWED_MATRIX}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return LoyaltyAllowedMatrixDtoListToEntityList(response);
            },
        }),
        LoyaltyAllowedMatrixUpdate: builder.mutation<LoyaltyAllowedMatrixEntity, FormMutation<LoyaltyAllowedMatrixEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.LOYALTY_ALLOWED_MATRIX}`;
                const method = "PUT";

                const body = LoyaltyAllowedMatrixEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.LOYALTY_ALLOWED_MATRIX],
        }),
        LoyaltyAllowedMatrixDelete: builder.mutation<LoyaltyAllowedMatrixEntity, LoyaltyAllowedMatrixQueryParams>({
            query: (loyaltyAllowedMatrixQueryParams) => {
                const dataGroup = getAssignedDataGroup();

                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.LOYALTY_ALLOWED_MATRIX}/${loyaltyAllowedMatrixQueryParams.id}`,
                    method: "DELETE",
                };
            },
            invalidatesTags: [ResourceName.LOYALTY_ALLOWED_MATRIX],
        }),
    }),
});

export const { useLoyaltyAllowedMatrixLoadQuery, useLoyaltyAllowedMatrixUpdateMutation, useLoyaltyAllowedMatrixDeleteMutation } =
    LoyaltyAllowedMatrixApi;
